/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchRecordUiAcknowledgements} from '../api'

export const useMutationBatchRecordUiAcknowledgements = createReactQueryMutationHook('batchRecordUiAcknowledgements', batchRecordUiAcknowledgements)
